import React from "react";
import "./style.css";
import { RiArrowGoBackLine, RiHome5Fill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

const PopupEspecialidadeEspontanea = ({close}) => {
    const navigate = useNavigate()

    const handle_close = () =>{
        close(false)
    }
    const handle_initial = () =>{
        navigate("/")
    }

    return (
        <div className="pop_contain">
            <h2 className="title_pop_espontaneo">
                Atendimento por Ordem de Chegada
            </h2>
            <p className="text_pop">O dia selecionado nesta unidade opera em ordem de chegada. Agradecemos sua compreensão.</p>
            <div className="content_submit">
                <p>Deseja escolher outro dia para atendimento?</p>
                <div className="button_group">
                    <button onClick={handle_close} className="button_yes"><RiArrowGoBackLine />Sim</button>
                    <button onClick={handle_initial} className="button_back"><RiHome5Fill />Voltar ao Início</button>
                </div>
            </div>
        </div>
    );
};

export default PopupEspecialidadeEspontanea;
